import React from "react";
import { Routes, Route } from "react-router-dom";
import "@fontsource/noto-sans-kr";
import "./assets/styles/css.css";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import MainPage from "./pages/main/MainPage";
import MyCorpPage from "./pages/mycorp/MyCorpPage";
import Login from "./pages/login/Login";
import Terms from "./pages/login/Terms";
import Join from "./pages/login/Join";
import MainDetailPage from "./pages/mainDetail/MainDetailPage";
import NewsPage from "./pages/news/NewsPage";
import SingleNews from "./pages/singleNews/SingleNews";
import TimelinePage from "./pages/timeline/TimelinePage";
import StockPage from "./pages/stock/StockPage";
import SettingPage from "./pages/setting/SettingPage";
import RealtimeNews from "./components/header/RealtimeNews";
import NewsScrapPage from "./pages/newsScrap/NewsScrapPage";
import CorpPage from "./pages/corp/CorpPage";
import Error400 from "./pages/error/Error400";
import Error500 from "./pages/error/Error500";
import NoData from "./pages/error/NoData";
import DartSingleNews from "./pages/singleNews/DartSingleNews";
import Policy from "./pages/Policy";
import Admin from "./pages/admin/Admin";
import { Helmet } from "react-helmet";
import PolistarSingleNews from "./pages/singleNews/PolistarSingleNews";
import Authorization from "./components/common/Authorization";

function App() {
  const isPolicyPage = window.location.pathname.includes("policy");

  return (
    <>
      <Helmet>
        <title>뉴스썸</title>
        <meta
          name="description"
          content="시간을 절약하고 싶은 사람들을 위한 1인신문,검색이 필요없는 초개인화 1인신문"
        />
        <meta
          name="keywords"
          content="투디지트,2digit,뉴스썸,뉴스,뉴스분석,뉴스추천,1인신문,신문,초거대언어모델,인공지능,newssum,news summary,summary,news,news recommendation"
        />
      </Helmet>
      {!isPolicyPage && <Header />}
      {!isPolicyPage && <RealtimeNews />}
      <Routes>
        <Route path="/" element={<MainPage />} /> {/* 메인 페이지 */}
        <Route path="/industry" element={<MainDetailPage />} />{" "}
        {/* 메인 전체 -> 산업 상세 페이지 */}
        <Route path="/theme" element={<MainDetailPage />} />{" "}
        {/* 메인 전체 -> 테마 상세 페이지 */}
        <Route path="/mycorp" element={<MyCorpPage />} />{" "}
        {/* 마이기업 페이지 */}
        <Route path="/mycorp/industry" element={<MainDetailPage />} />{" "}
        {/* 마이 전체 -> 산업 상세 페이지 */}
        <Route path="/mycorp/theme" element={<MainDetailPage />} />{" "}
        {/* 마이 전체 -> 테마 상세 페이지 */}
        <Route path="/news" element={<NewsPage />} />{" "}
        {/* 전체 뉴스 목록 페이지 */}
        <Route path="/news/:type/:signal" element={<NewsPage />} />{" "}
        {/* 종목 뉴스 목록 페이지 */}
        <Route path="/single-news/:id" element={<SingleNews />} />{" "}
        {/* 개별 뉴스  페이지 */}
        <Route path="/dart-news/:id" element={<DartSingleNews />} />{" "}
        {/* 개별 공시 뉴스  페이지 */}
        <Route path="/polistar/:id" element={<PolistarSingleNews />} />{" "}
        {/* 폴리스타에 연동된 뉴스썸 개별  페이지 */}
        <Route path="/:id/timeline" element={<TimelinePage />} />{" "}
        {/* 연관뉴스 타임라인 페이지 */}
        <Route path="/corp" element={<CorpPage />} /> {/* 기업 페이지 */}
        <Route path="/stock/:stockcode" element={<StockPage />} />{" "}
        {/* 개별 종목 페이지 */}
        <Route path="/scrap" element={<NewsScrapPage />} />{" "}
        {/*뉴스 스크랩 페이지*/}
        <Route path="/login" element={<Login />} /> {/* 로그인 페이지 */}
        <Route path="/join/terms" element={<Terms />} />{" "}
        {/* 약관 동의 페이지 */}
        <Route path="/join" element={<Join />} /> {/* 회원가입 페이지 */}
        <Route path="/policy/:policy" element={<Policy />} />{" "}
        {/* 약관 페이지 */}
        <Route path="/setting" element={<SettingPage />} /> {/* 설정 페이지 */}
        <Route path="/error" element={<Error500 />} /> {/* 500 status 페이지 */}
        <Route path="/nodata" element={<NoData />} />{" "}
        {/* fail data 내용 페이지 */}
        <Route path="*" element={<Error400 />} />
        <Route
          path="/admin"
          element={<Authorization children={<Admin />} redirectTo={`/login`} />}
        />
        {/* 뉴스등록 어드민 페이지 */}
      </Routes>
      {!isPolicyPage && <Footer />}
    </>
  );
}

export default App;
